import wholesales from '@/components/wholesales/Wholesales'

export default [
  {
    path: '/wholesales',
    name: 'wholesales',
    component: wholesales,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/wholesalesRoutes.js